import { orgId } from 'components/StructuredData/SchemaOrg';
import { JsonObject } from 'lib/json';
import { removeIfUndefined } from 'lib/util';
import { Job } from './api';

export function jobSchema(domain: string, job: Job & { content?: string }): JsonObject {
  return {
    '@type': 'JobPosting',
    title: job.title,
    identifier: job.id,
    ...removeIfUndefined({ description: job.content }),
    hiringOrganization: {
      '@type': 'Organization',
      '@id': orgId(domain),
    },
    jobLocation: {
      '@type': 'Place',
      address: {
        '@type': 'PostalAddress',
        addressRegion: job.state,
      },
    },
  };
}
